module.exports = "<table dt-options=\"$ctrl.dtOptions\" class=\"table table-striped datatable-conduu\" style=\"width:100%\">\r\n  <thead>\r\n  <tr>\r\n    <th ng-repeat=\"column in $ctrl.dtSettings.data.columns\">{{column}}</th>\r\n  </tr>\r\n  </thead>\r\n  <tbody>\r\n  <tr ng-repeat=\"row in $ctrl.dtData\">\r\n    <td ng-repeat=\"cell in row track by $index\">{{cell}}</td>\r\n  </tr>\r\n  </tbody>\r\n</table>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/components/datatable/datatable.component.html
// module id = 707
// module chunks = 0